import { Column } from 'primereact/column';
import React from 'react';
import { useEpdProductDangerMaterials } from 'services/api/queries';
import { HeaderCaptionSemiBold } from 'styles/v2/Styles.styled';
import { EPDContentDeclarationProductType } from 'types/content-declaration/EPDContentDeclarationProductType';
import { DataTableStyled } from '../StyledGrid';
import { useContentDeclarationTerminologyHelper } from '../../hooks/useContentDeclarationTerminologyHelper';
import { numericCellBody } from '../GridService';

const header = (
  <div className="flex flex-wrap align-items-center justify-content-between gap-2">
    <HeaderCaptionSemiBold className="white-space-nowrap">Hazardous and toxic Substances</HeaderCaptionSemiBold>
  </div>
);

const DangerMaterialsGridPdf: React.FunctionComponent<{
  epdVersionId: string;
  contentDeclarationType: EPDContentDeclarationProductType;
  hasDangerMaterials?: boolean | null;
  className?: string;
}> = ({ epdVersionId, contentDeclarationType, hasDangerMaterials, className }) => {
  const rows = useEpdProductDangerMaterials(epdVersionId!, contentDeclarationType).data;
  const { replaceInString } = useContentDeclarationTerminologyHelper();

  const isEmpty = !rows || rows.length === 0;
  if (isEmpty && (contentDeclarationType !== EPDContentDeclarationProductType.Average || hasDangerMaterials === false)) {
    return null;
  }

  return (
    <DataTableStyled
      className={className}
      header={header}
      value={rows}
      dataKey="id"
      tableStyle={{ minWidth: '49rem', tableLayout: 'fixed' }}
      style={{ display: 'grid', overflow: 'auto' }}
      showGridlines
    >
      <Column field="name" header="Hazardous/Toxic substances from the candidate list" style={{ wordBreak: 'break-all' }} />
      <Column field="ecNo" header="EC No." style={{ width: '7rem' }} />
      <Column field="casNo" header="CAS No." style={{ width: '7rem' }} />
      <Column
        field="weightPercent"
        header={replaceInString('Weight per functional or declared unit %')}
        style={{ width: '15rem' }}
        body={numericCellBody()}
      />
    </DataTableStyled>
  );
};

export default DangerMaterialsGridPdf;
